export const getClassNames = (...classNames: unknown[]) =>
    classNames
        .map((className) => typeof className === 'string' && className)
        .filter(Boolean)
        .join(' ')
